<template>
    <div id="all">
        <main id="main" class="has-nav">
            <div class="container">

                <h1 class="title line">Manage Parameters</h1>

                <tabs-component :tabs="tabs" :components="components"/>
            </div>

        </main>

        <div id="popup-box">
            <div class="container">
                <div class="popup form-popup" id="new-terminal-types-popup">
                    <div class="popup-box">
                        <p class="h2 title line">Add New LX Terminal Types</p>
                        <form action="#" class="form">
                            <div class="field">
                                <label class="field-name">Name</label>
                                <input type="text" class="form-control" placeholder="Type LX Terminal">
                            </div>
                            <div class="field">
                                <label class="field-name">Ref</label>
                                <input type="email" class="form-control" placeholder="Type Ref">
                            </div>
                            <div class="form-btn-box">
                                    <span href="" class="btn success no-bg small js-close-popup">
                                        <svg width="20" height="21" viewBox="0 0 20 21" fill="none"
                                             xmlns="http://www.w3.org/2000/svg">
                                            <path d="M3 3L17 17" stroke="#00AF41" stroke-width="2"/>
                                            <path d="M17 3L3 17" stroke="#00AF41" stroke-width="2"/>
                                        </svg>
                                        <span>Cancel</span>
                                    </span>
                                <button type="button" class="btn success small">
                                    <svg width="20" height="21" viewBox="0 0 20 21" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="10" cy="10.5" r="9" stroke="white" stroke-width="2"/>
                                        <path d="M5.00879 10.0106L8.99799 13.9997L14.9909 8.00684" stroke="white"
                                              stroke-width="2"/>
                                    </svg>
                                    <span>ADD</span>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
                <div class="popup form-popup" id="new-subscription-popup">
                    <div class="popup-box">
                        <p class="h2 title line">Add New LX Subscriptions</p>
                        <form action="#" class="form">
                            <div class="field">
                                <label class="field-name">Name</label>
                                <input type="text" class="form-control" placeholder="Type LX Subscriptions">
                            </div>
                            <div class="field">
                                <label class="field-name">Ref</label>
                                <input type="email" class="form-control" placeholder="Type Ref">
                            </div>
                            <div class="form-btn-box">
                                    <span href="" class="btn success no-bg small js-close-popup">
                                        <svg width="20" height="21" viewBox="0 0 20 21" fill="none"
                                             xmlns="http://www.w3.org/2000/svg">
                                            <path d="M3 3L17 17" stroke="#00AF41" stroke-width="2"/>
                                            <path d="M17 3L3 17" stroke="#00AF41" stroke-width="2"/>
                                        </svg>
                                        <span>Cancel</span>
                                    </span>
                                <button type="button" class="btn success small">
                                    <svg width="20" height="21" viewBox="0 0 20 21" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="10" cy="10.5" r="9" stroke="white" stroke-width="2"/>
                                        <path d="M5.00879 10.0106L8.99799 13.9997L14.9909 8.00684" stroke="white"
                                              stroke-width="2"/>
                                    </svg>
                                    <span>ADD</span>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
                <div class="popup form-popup" id="edit-terminal-types-popup">
                    <div class="popup-box">
                        <p class="h2 title line">Edit LX Terminal Types</p>
                        <form action="#" class="form">
                            <div class="field">
                                <label class="field-name">Name</label>
                                <select name="select" class="select select-edit" data-placeholder="Name">
                                    <option value="Cobham 6075 LX">Cobham 6075 LX</option>
                                    <option value="Cobham 8100 GX">Cobham 8100 GX</option>
                                    <option value="Paradigm Connect 180">Paradigm Connect 180</option>
                                    <option value="Paradigm Connect 100T">Paradigm Connect 100T</option>
                                </select>
                            </div>
                            <div class="field">
                                <label class="field-name">Ref</label>
                                <select name="select" class="select select-edit" data-placeholder="Ref">
                                    <option value="COL-LAN-SCM-0750610">COL-LAN-SCM-0750610</option>
                                    <option value="COL-LAN-SCM-0750608">COL-LAN-SCM-0750608</option>
                                    <option value="COL-LAN-SCM-0750604">COL-LAN-SCM-0750604</option>
                                    <option value="COL-LAN-SCM-100060C">COL-LAN-SCM-100060C</option>
                                </select>
                            </div>
                            <div class="form-btn-box">
                                    <span href="" class="btn success no-bg small js-close-popup">
                                        <svg width="20" height="21" viewBox="0 0 20 21" fill="none"
                                             xmlns="http://www.w3.org/2000/svg">
                                            <path d="M3 3L17 17" stroke="#00AF41" stroke-width="2"/>
                                            <path d="M17 3L3 17" stroke="#00AF41" stroke-width="2"/>
                                        </svg>
                                        <span>Cancel</span>
                                    </span>
                                <button type="button" class="btn success small">
                                    <svg width="20" height="21" viewBox="0 0 20 21" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="10" cy="10.5" r="9" stroke="white" stroke-width="2"/>
                                        <path d="M5.00879 10.0106L8.99799 13.9997L14.9909 8.00684" stroke="white"
                                              stroke-width="2"/>
                                    </svg>
                                    <span>SAVE</span>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
                <div class="popup form-popup" id="edit-terminal-subscription-popup">
                    <div class="popup-box">
                        <p class="h2 title line">Edit LX Subscription</p>
                        <form action="#" class="form">
                            <div class="field">
                                <label class="field-name">Name</label>
                                <select name="select" class="select select-edit" data-placeholder="Name">
                                    <option value="LX EVENT-2048/4096 24M">LX EVENT-2048/4096 24M</option>
                                    <option value="LX EVENT-2048/2048 24M">LX EVENT-2048/2048 24M</option>
                                    <option value="LX EVENT-512/4096 24M">LX EVENT-512/4096 24M</option>
                                    <option value="LX EVENT-4096/4096 24M">LX EVENT-4096/4096 24M</option>
                                </select>
                            </div>
                            <div class="field">
                                <label class="field-name">Ref</label>
                                <select name="select" class="select select-edit" data-placeholder="Ref">
                                    <option value="SPID-10747">SPID-10747</option>
                                    <option value="SPID-TBC">SPID-TBC</option>
                                    <option value="SPID- TBC">SPID- TBC</option>
                                    <option value="SPID- TBC">SPID- TBC</option>
                                </select>
                            </div>
                            <div class="form-btn-box">
                                    <span href="" class="btn success no-bg small js-close-popup">
                                        <svg width="20" height="21" viewBox="0 0 20 21" fill="none"
                                             xmlns="http://www.w3.org/2000/svg">
                                            <path d="M3 3L17 17" stroke="#00AF41" stroke-width="2"/>
                                            <path d="M17 3L3 17" stroke="#00AF41" stroke-width="2"/>
                                        </svg>
                                        <span>Cancel</span>
                                    </span>
                                <button type="button" class="btn success small">
                                    <svg width="20" height="21" viewBox="0 0 20 21" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="10" cy="10.5" r="9" stroke="white" stroke-width="2"/>
                                        <path d="M5.00879 10.0106L8.99799 13.9997L14.9909 8.00684" stroke="white"
                                              stroke-width="2"/>
                                    </svg>
                                    <span>SAVE</span>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
                <div class="popup" id="delete-popup">
                    <div class="popup-box">
                        <p class="h2 title">Are you sure you want to delete this?</p>

                        <div class="buttons-box">
                                <span class="btn success no-bg js-close-popup">
                                    <svg width="20" height="21" viewBox="0 0 20 21" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path d="M3 3L17 17" stroke="#00AF41" stroke-width="2"/>
                                        <path d="M17 3L3 17" stroke="#00AF41" stroke-width="2"/>
                                    </svg>
                                    <span>NO</span>
                                </span>
                            <span class="btn danger will-deactivate-btn">
                                    <svg width="20" height="21" viewBox="0 0 20 21" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path d="M14.5 4.8H19V6.7H17.2V19.05C17.2 19.302 17.1052 19.5436 16.9364 19.7218C16.7676 19.8999 16.5387 20 16.3 20H3.7C3.46131 20 3.23239 19.8999 3.0636 19.7218C2.89482 19.5436 2.8 19.302 2.8 19.05V6.7H1V4.8H5.5V1.95C5.5 1.69804 5.59482 1.45641 5.7636 1.27825C5.93239 1.10009 6.1613 1 6.4 1H13.6C13.8387 1 14.0676 1.10009 14.2364 1.27825C14.4052 1.45641 14.5 1.69804 14.5 1.95V4.8ZM15.4 6.7H4.6V18.1H15.4V6.7ZM7.3 9.55H9.1V15.25H7.3V9.55ZM10.9 9.55H12.7V15.25H10.9V9.55ZM7.3 2.9V4.8H12.7V2.9H7.3Z"
                                              fill="white"/>
                                    </svg>
                                    <span>DELETE</span>
                                </span>
                        </div>
                    </div>
                </div>

                <div class="popup filter-popup" id="filter-popup">
                    <div class="popup-box">
                        <div class="title-popup-wrap">
                            <span class="reset">reset</span>
                            <p class="title">Filter</p>
                            <span class="js-close-popup">
                                    <svg width="15" height="15" viewBox="0 0 15 15" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path d="M14 1L1 14" stroke="#4D4D4F" stroke-width="1.5"/>
                                        <path d="M14 14L1 1" stroke="#4D4D4F" stroke-width="1.5"/>
                                    </svg>
                                </span>
                        </div>
                        <div class="filter-popup-item">
                            <div class="item-wrap">
                                <span>Name</span>
                                <div class="arrow-icon">
                                    <svg width="19" height="11" viewBox="0 0 19 11" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                              d="M0.796143 2.31541L2.50819 0.251343L9.49999 6.78477L16.4918 0.251343L18.2038 2.31541L9.49999 10.4487L0.796143 2.31541Z"
                                              fill="#00AF41"/>
                                    </svg>
                                </div>
                            </div>
                            <div class="select-result">
                                <p>Cobham 6075 LX</p>
                            </div>
                            <div class="filter-dropdown-box">
                                <select name="select" class="select select-search" data-placeholder="Name subscription">
                                    <option></option>
                                    <option value="Cobham 6075 LX">Cobham 6075 LX</option>
                                    <option value="Cobham 8100 GX">Cobham 8100 GX</option>
                                    <option value="Paradigm Connect 180">Paradigm Connect 180</option>
                                    <option value="Paradigm Connect 100T">Paradigm Connect 100T</option>
                                </select>
                            </div>
                        </div>
                        <div class="filter-popup-item">
                            <div class="item-wrap">
                                <span>Ref</span>
                                <div class="arrow-icon">
                                    <svg width="19" height="11" viewBox="0 0 19 11" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                              d="M0.796143 2.31541L2.50819 0.251343L9.49999 6.78477L16.4918 0.251343L18.2038 2.31541L9.49999 10.4487L0.796143 2.31541Z"
                                              fill="#00AF41"/>
                                    </svg>
                                </div>
                            </div>
                            <div class="select-result">
                                <p>COL-LAN-SCM-0750610</p>
                            </div>
                            <div class="filter-dropdown-box">
                                <select name="select" class="select select-search" data-placeholder="Ref">
                                    <option></option>
                                    <option value="COL-LAN-SCM-0750610">COL-LAN-SCM-0750610</option>
                                    <option value="COL-LAN-SCM-0750608">COL-LAN-SCM-0750608</option>
                                    <option value="COL-LAN-SCM-0750604">COL-LAN-SCM-0750604</option>
                                    <option value="COL-LAN-SCM-100060C">COL-LAN-SCM-100060C</option>
                                </select>
                            </div>
                        </div>
                        <div class="btn-box">
                            <span href="" class="btn light-green js-close-popup reset">Cancel</span>
                            <span class="btn success submit">Submit</span>
                        </div>
                    </div>
                </div>
                <div class="popup filter-popup" id="filter-popup2">
                    <div class="popup-box">
                        <div class="title-popup-wrap">
                            <span class="reset">reset</span>
                            <p class="title">Filter</p>
                            <span class="js-close-popup">
                                    <svg width="15" height="15" viewBox="0 0 15 15" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path d="M14 1L1 14" stroke="#4D4D4F" stroke-width="1.5"/>
                                        <path d="M14 14L1 1" stroke="#4D4D4F" stroke-width="1.5"/>
                                    </svg>
                                </span>
                        </div>
                        <div class="filter-popup-item">
                            <div class="item-wrap">
                                <span>Name</span>
                                <div class="arrow-icon">
                                    <svg width="19" height="11" viewBox="0 0 19 11" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                              d="M0.796143 2.31541L2.50819 0.251343L9.49999 6.78477L16.4918 0.251343L18.2038 2.31541L9.49999 10.4487L0.796143 2.31541Z"
                                              fill="#00AF41"/>
                                    </svg>
                                </div>
                            </div>
                            <div class="select-result">
                                <p>LX EVENT-2048/4096 24M</p>
                            </div>
                            <div class="filter-dropdown-box">
                                <select name="select" class="select select-search"
                                        data-placeholder="Name terminal types">
                                    <option></option>
                                    <option value="LX EVENT-2048/4096 24M">LX EVENT-2048/4096 24M</option>
                                    <option value="LX EVENT-2048/2048 24M">LX EVENT-2048/2048 24M</option>
                                    <option value="LX EVENT-512/4096 24M">LX EVENT-512/4096 24M</option>
                                    <option value="LX EVENT-4096/4096 24M">LX EVENT-4096/4096 24M</option>
                                </select>
                            </div>
                        </div>
                        <div class="filter-popup-item">
                            <div class="item-wrap">
                                <span>Ref</span>
                                <div class="arrow-icon">
                                    <svg width="19" height="11" viewBox="0 0 19 11" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                              d="M0.796143 2.31541L2.50819 0.251343L9.49999 6.78477L16.4918 0.251343L18.2038 2.31541L9.49999 10.4487L0.796143 2.31541Z"
                                              fill="#00AF41"/>
                                    </svg>
                                </div>
                            </div>
                            <div class="select-result">
                                <p>SPID-10747</p>
                            </div>
                            <div class="filter-dropdown-box">
                                <select name="select" class="select select-search" data-placeholder="Ref">
                                    <option></option>
                                    <option value="SPID-10747">SPID-10747</option>
                                    <option value="SPID-TBC">SPID-TBC</option>
                                    <option value="SPID- TBC">SPID- TBC</option>
                                    <option value="SPID- TBC">SPID- TBC</option>
                                </select>
                            </div>
                        </div>
                        <div class="btn-box">
                            <span href="" class="btn light-green js-close-popup reset">Cancel</span>
                            <span class="btn success submit">Submit</span>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>

import TabsComponent from "../Tabs";
import EmailSettings from "./Settings/EmailSettings"
import LXSettings from "./Settings/LXSettings"
import {markRaw} from "vue"

const components = markRaw({
    EmailSettings, LXSettings
});


export default {
    name: 'settings',

    components: {TabsComponent},

    data() {
        return {
            components,

            tabs: [
                {
                    title: "Email Settings",
                    class: 'email-settings-box'
                },
                {
                    title: "LX Settings",
                    class: 'lx-settings-box'
                }

            ],
        }
    },

    mounted() {
    },

    computed: {

    },

    methods: {

    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
